















import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'IconSingleArrowLeft',
  props: {
    width: {
      type: String,
      default: '6.537',
    },
    height: {
      type: String,
      default: '12',
    },
  },
});
